import { Typography } from "@mui/material"
import MiniDivider from "components/shared/MiniDivider"
import React from "react"
import { flexBox } from "style/style_snippets"

const titleDescriptionStyle = {
  ...flexBox.column,
  alignItems: "flex-start",
}

const TitleDescription = ({ title, description, detail, additionalCss }) => {
  return (
    <div css={[titleDescriptionStyle, additionalCss]}>
      <Typography variant={"overline"}>{description}</Typography>
      <MiniDivider />
      <Typography variant={"h2"}>{title}</Typography>
      {detail ? (
        typeof detail === "object" ? (
          detail
        ) : (
          <Typography variant={"overline"}>{detail}</Typography>
        )
      ) : null}
    </div>
  )
}

export default TitleDescription
